import { createReducer, on } from '@ngrx/store';

import { ISections, IToken } from '../../shared/models/ProgramClose';
import {
    clearSeccionesPremiados,
    clearTokenPremiados,
    errorSeccionesPremiados,
    errorTokenPremiados,
    getSeccionesPremiados,
    getTokenPremiados,
    successSeccionesPremiados,
    successTokenPremiados,
} from '../actions';

interface IControlState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
}

/*
 * Obtiene token de consulta premiados
 */
export interface TokenPremiadosState extends IControlState {
    data: IToken;
}

export const TokenPremiadosInit: TokenPremiadosState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    data: { token: '', message: '', success: false, },
}

const _tokenPremiadosReducer = createReducer(
    TokenPremiadosInit,
    on(getTokenPremiados, state => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false,
        }
    )),
    on(successTokenPremiados, (state, resp) => (
        {
            ...state,
            loading: false,
            success: true,
            data: { ...resp.data, message: resp.message, success: resp.success },
        }
    )),
    on(errorTokenPremiados, (state, { payload }) => (
        {
            ...state,
            loading: false,
            failed: true,
            error: payload
        }
    )),
    on(clearTokenPremiados, state => ({ ...state, ...TokenPremiadosInit })),
);

export function TokenPremiadosReducer(state: any, action: any) {
    return _tokenPremiadosReducer(state, action);
}

/*
 * Obtiene las secciones de premiados
 */
export interface SectionsPremiadosState extends IControlState {
    data: ISections[];
}

export const SectionsPremiadosInit: SectionsPremiadosState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    data: [],
}

const _sectionsPremiadosReducer = createReducer(
    SectionsPremiadosInit,
    on(getSeccionesPremiados, state => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false,
        }
    )),
    on(successSeccionesPremiados, (state, { data }) => (
        {
            ...state,
            loading: false,
            success: true,
            data,
        }
    )),
    on(errorSeccionesPremiados, (state, { payload }) => (
        {
            ...state,
            loading: false,
            failed: true,
            error: payload
        }
    )),
    on(clearSeccionesPremiados, state => ({ ...state, ...SectionsPremiadosInit })),
);

export function SectionsPremiadosReducer(state: any, action: any) {
    return _sectionsPremiadosReducer(state, action);
}

